import React, { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { RowsAdditionalContentRenderer$key } from '@atlassian/jira-relay/src/__generated__/RowsAdditionalContentRenderer.graphql';
import { useTimelineCustomComponents } from '../../../controllers/timeline-custom-components/index.tsx';

export type RowsAdditionalContentRendererProps = {
	depth: number;
	groupId?: string;
	issues: RowsAdditionalContentRenderer$key;
};

export const RowsAdditionalContentRenderer: FC<RowsAdditionalContentRendererProps> = ({
	depth,
	groupId,
	issues,
}) => {
	const timelineCustomComponents = useTimelineCustomComponents();

	const issuesData = useFragment(
		graphql`
			fragment RowsAdditionalContentRenderer on JiraIssueConnection
			@argumentDefinitions(isTimelineEnabled: { type: "Boolean!" }) {
				# eslint-disable-next-line @atlassian/relay/must-colocate-fragment-spreads
				...TimelineRowsContent @include(if: $isTimelineEnabled)
			}
		`,
		issues,
	);

	return (
		timelineCustomComponents?.RowsAdditionalContent && (
			<timelineCustomComponents.RowsAdditionalContent
				depth={depth}
				groupId={groupId}
				issues={issuesData}
			/>
		)
	);
};
